import React from 'react';
import { BubbleMenu, EditorContent, useEditorState } from '@tiptap/react';
import PropTypes from 'prop-types';

import './styles.scss';

const TipTapRichTextEditor = ({ editor }) => {
  /**
   * This hook allows us to select the editor state we want to use in our component.
   */
  const currentEditorState = useEditorState({
    /**
     * The editor instance we want to use.
     */
    editor,
    /**
     * This selector allows us to select the data we want to use in our component.
     * It is evaluated on every editor transaction and compared to it's previously returned value.
     */
    selector: ctx => ({
      isBold: ctx.editor.isActive('bold'),
      isItalic: ctx.editor.isActive('italic'),
      isStrike: ctx.editor.isActive('strike')
    }),
    /**
     * This function allows us to customize the equality check for the selector.
     * By default it is a `===` check.
     */
    equalityFn: (prev, next) => {
      // A deep-equal function would probably be more maintainable here, but, we use a shallow one to show that it can be customized.
      if (!next) {
        return false;
      }

      return (
        prev.isBold === next.isBold
        && prev.isItalic === next.isItalic
        && prev.isStrike === next.isStrike
      );
    }
  });

  return (
    <>
      {currentEditorState && (
        <BubbleMenu className="bubble-menu" editor={editor} tippyOptions={{ duration: 100 }}>
          <button
            className={currentEditorState.isBold ? 'is-active' : ''}
            onClick={() => editor.chain()
              .focus()
              .toggleBold()
              .run()}
          >
            Bold
          </button>
          <button
            className={currentEditorState.isItalic ? 'is-active' : ''}
            onClick={() => editor.chain()
              .focus()
              .toggleItalic()
              .run()}
          >
            Italic
          </button>
          <button
            className={currentEditorState.isStrike ? 'is-active' : ''}
            onClick={() => editor.chain()
              .focus()
              .toggleStrike()
              .run()}
          >
            Strike
          </button>
          <button
            className={editor.isActive('bulletList') ? 'is-active' : ''}
            onClick={() => editor.chain()
              .focus()
              .toggleBulletList()
              .run()}
          >
            Bullet list
          </button>
        </BubbleMenu>
      )}
      <EditorContent editor={editor} />
    </>
  );
};

TipTapRichTextEditor.propTypes = { editor: PropTypes.object.isRequired };

export default TipTapRichTextEditor;
